import { Directive, Input, ElementRef, HostListener, OnChanges, inject } from "@angular/core";
import Autolinker from "autolinker";

@Directive({
    selector: "[linkify]",
    standalone: false
})
export class LinkifyDirective implements OnChanges {
    private _elementRef = inject(ElementRef);
    @Input("content") content: string;

    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        if (changes.content) {
            const innerContent = this.content
                ? Autolinker.link(this.content, {
                      newWindow: true,
                      stripPrefix: false
                  })
                : this.content;
            this._elementRef.nativeElement.innerHTML = innerContent;
        }
    }

    @HostListener("click", ["$event"])
    onMouseClick(event: MouseEvent) {
        if ((<Element>event.target).classList.contains("linkified")) {
            event.stopPropagation();
        }
    }
}
